<template>
    <el-header class="app-header">
        <div class="left">
            <h1 class="logo">{{ route.meta?.pageName }}</h1>
        </div>

        <div class="right">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    <el-icon>
                        <Avatar />
                    </el-icon>
                    <span class="username">{{ adminStore.admin || '管理员' }}</span>
                    <el-icon>
                        <ArrowDown />
                    </el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="openChangePassword">修改密码</el-dropdown-item>
                        <el-dropdown-item divided @click="handleLogout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <!-- 修改密码弹框 -->
        <el-dialog v-model="pwdParams.showPwdDialog" title="修改密码" width="400px">
            <el-form ref="pwdForm" :model="pwdParams" label-width="100px" :rules="rules">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input type="password" v-model="pwdParams.oldPassword" />
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input type="password" v-model="pwdParams.newPassword" @keyup.enter="submitChangePassword" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="pwdParams.showPwdDialog = false">取消</el-button>
                <el-button v-loading="pwdParams.loading" type="primary" @click="submitChangePassword">确定</el-button>
            </template>
        </el-dialog>
    </el-header>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAdminStore } from '@/stores/admin';
import { ElMessage } from 'element-plus';

const route = useRoute();
const router = useRouter();
const adminStore = useAdminStore();

const pwdParams = reactive({
    showPwdDialog: false,
    oldPassword: '',
    newPassword: '',
    loading: false,
});

const pwdForm = ref(null);

const rules = {
    oldPassword: [
        { required: true, message: "Old password can not be empty", trigger: "blur" },
    ],
    newPassword: [
        { required: true, message: "New password can not be empty", trigger: "blur" },
    ],
};

const openChangePassword = () => {
    pwdParams.oldPassword = "";
    pwdParams.newPassword = "";
    pwdParams.showPwdDialog = true;
}

const submitChangePassword = async () => {
    if (pwdParams.loading) {
        return;
    }

    pwdForm.value.validate(async valid => {
        if (valid) {
            pwdParams.loading = true;
            await adminStore.modifyPwd(pwdParams.oldPassword, pwdParams.newPassword);
            pwdParams.loading = false;
            ElMessage.success('密码修改成功');
            pwdParams.showPwdDialog = false;
        } else {
            ElMessage.error('请填写所有必填项');
        }
    });
}

const handleLogout = async () => {
    adminStore.logout();
    router.push('/login');
}
</script>

<style scoped>
.app-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 60px;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
}

.left .logo {
    font-size: 18px;
    font-weight: bold;
    color: #409eff;
}

.right {
    display: flex;
    align-items: center;
}

.el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.username {
    margin: 0 8px;
    font-size: 14px;
    color: #333;
}
</style>
